<template>
  <div class="textArea">
    <textarea v-if="validationMethod === 'onBlur'" :id="inputId" rows="5" cols="50" :class="{error : validationError}" @blur="getInput($event.target.value)" type="text" v-model="inputValue" :disabled="disabled" required></textarea>
    <textarea v-else-if="validationMethod === 'onChange'" :id="inputId" rows="5" cols="50" :class="{error : validationError}" @blur="getInput($event.target.value)" type="text" v-model="inputValue" :disabled="disabled" required></textarea>
    <i v-if="icon" :class="icon"></i>
    <button v-if="button" class="btn-small small-font">{{button}}</button>
    <label class="subhead">{{label}}</label>
    <p v-if="validationError" class="msg-error small-font">{{message}}</p>
  </div>
</template>

<script>
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-form-textarea',
  props: {
    label: {
      required: false
    },
    value: {
      required: false
    },
    error: {
      required: false
    },
    icon: {
      required: false
    },
    button: {
      required: false
    },
    validation: {
      required: false
    },
    validationMethod: {
      required: false,
      default: `onBlur`
    },
    disabled: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    },
    inputId: {
      required: false,
      default: ''
    },
  },
  data() {
    return {
      initial: true,
      inputValue: undefined,
      valid: undefined,
      message: undefined
    }
  },
  mounted() {
    this.$data.inputValue = this.value
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
  },
  methods: {
    getInput(value) {
      this.validateInput(value)
    },
    validateInput(value) {
      if (this.validation) {
        const { valid, message } = validate(this.validation, value, this.label)
        if(valid) {
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          // this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
        this.$emit(`update:value`, value)
        this.$emit(`update:error`, false)
      }
      this.$emit(`update:isInitial`, false)
    }
  },
  watch: {
    inputValue: helpers.debounce(function() {
      if(this.validationMethod === `onChange`) {
        if (!this.initial) {
          this.validateInput(this.inputValue)
        } else {
          this.initial = false
        }
      }
    }, 500),
    value: function () {
      this.inputValue = this.value
    },
    error: function () {
      if (typeof(this.error) == 'string') {
        this.message = this.error
      }
    }
  },
  computed: {
    validationError: function () {
      if (this.error) return this.error
      return this.valid === undefined ? false : !this.valid
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>